import styles from './ListViewRow.module.scss'
import React from 'react'
import classNames from 'classnames'

type Props = {
  children: React.ReactNode
  className?: string
}

const ListViewRow = (props: Props) => {
  return (
    <div className={classNames(styles.component, props.className)}>
      {props.children}
    </div>
  )
}

export default ListViewRow
